import Table from "Shared/components/DataTable/Table"
import restClient from 'Shared/hooks/restClient'

const FlowsDatatable = ({ tableType, ballots }) => {
  const handleTableClick = (e) => {
    if(e.target.classList.contains('restore-flow')) {
      const flowId = e.target.dataset.flowId
      
      if (window.confirm('Are you sure you want to restore this page?')) {
        restClient.post(`/api/flows/${flowId}/restore`).then(() => {
          window.location.href = ballots ? '/admin/ballots' : '/admin/flows'
        })
      }
    }
  }

  const emptyTableMessage = ballots && tableType === 'all' ? "You've not set up any ballots yet." :
    ballots && tableType === 'archived' ? "You have no archived ballots." :
    tableType === 'all' ? "You've not set up any pages yet." :
    "You have no archived pages."

  const tableProps = {
    table: 'flows',
    scope: { section: ballots ? 'ballots' : 'pages' },
    language: { emptyTable: emptyTableMessage },
    includeTypeParam: true,
    onClick: handleTableClick,
  }

  return (
    <div className="section">
      <div className="box">
        <div className="header">
          <h2>Your {ballots ? 'ballots' : 'pages'}</h2>
        </div>

        <Table {...tableProps} />
      </div>
    </div>
  )
}

export default FlowsDatatable
